export const CURRENCY_SIGNS: Record<string, string> = {
    RUB: '₽',
    KZT: '₸',
    UAH: '₴',
    KGS: 'сом',
    EUR: '€',
    BGJ: 'лв',
    BGK: 'лв',
    BGL: 'лв',
    BGN: 'лв',
    MXN: '$',
    PLN: 'zł',
    CZK: 'Kč',
    CSJ: 'Kč',
    CSK: 'Kč',
    HUF: 'Ft',
    RON: 'lei',
    CLP: '$',
    COP: '$',
    MDL: 'L',
    USD: '$',
    BYN: 'Br',
    GTQ: 'Q',
    HNL: 'L',
    CRC: '₡',
    NIO: 'C$',
};
